var map = {
	"./blue/arrow.svg": 892,
	"./blue/arrows.svg": 3440,
	"./blue/cart.svg": 4662,
	"./blue/check-active.svg": 2733,
	"./blue/check.svg": 2216,
	"./blue/chevron.svg": 2968,
	"./blue/clock.svg": 3471,
	"./blue/close.svg": 7199,
	"./blue/lock.svg": 7016,
	"./blue/lotto/note.svg": 6392,
	"./blue/nav/history.svg": 9506,
	"./blue/nav/home.svg": 1688,
	"./blue/nav/print.svg": 9772,
	"./blue/nav/report-final.svg": 2842,
	"./blue/nav/report.svg": 3339,
	"./blue/nav/result.svg": 6532,
	"./blue/nav/scan.svg": 7947,
	"./blue/password.svg": 3411,
	"./blue/print.svg": 8946,
	"./blue/quickpick.svg": 6014,
	"./blue/refresh.svg": 5660,
	"./blue/replay.svg": 3012,
	"./blue/search.svg": 4702,
	"./blue/sign-out.svg": 1167,
	"./blue/user.svg": 1746,
	"./darkblue/arrow.svg": 3705,
	"./darkblue/arrows.svg": 7706,
	"./darkblue/cart.svg": 8861,
	"./darkblue/check-active.svg": 3032,
	"./darkblue/check.svg": 9902,
	"./darkblue/chevron.svg": 8763,
	"./darkblue/clock.svg": 8761,
	"./darkblue/close.svg": 9428,
	"./darkblue/lock.svg": 4454,
	"./darkblue/lotto/note.svg": 3585,
	"./darkblue/nav/history.svg": 7422,
	"./darkblue/nav/home.svg": 5429,
	"./darkblue/nav/print.svg": 6236,
	"./darkblue/nav/report-final.svg": 4021,
	"./darkblue/nav/report.svg": 3409,
	"./darkblue/nav/result.svg": 3346,
	"./darkblue/nav/scan.svg": 6158,
	"./darkblue/password.svg": 1197,
	"./darkblue/pen.svg": 6769,
	"./darkblue/print.svg": 6710,
	"./darkblue/quickpick.svg": 5780,
	"./darkblue/refresh.svg": 9447,
	"./darkblue/replay.svg": 378,
	"./darkblue/search.svg": 3485,
	"./darkblue/sign-out.svg": 6970,
	"./darkblue/user.svg": 6171,
	"./orange/arrow.svg": 6609,
	"./orange/arrows.svg": 142,
	"./orange/cart.svg": 1069,
	"./orange/check-active.svg": 4095,
	"./orange/check.svg": 9990,
	"./orange/chevron.svg": 2483,
	"./orange/clock.svg": 9711,
	"./orange/close.svg": 1259,
	"./orange/lock.svg": 8223,
	"./orange/lotto/note.svg": 94,
	"./orange/nav/history.svg": 2933,
	"./orange/nav/home.svg": 5419,
	"./orange/nav/print.svg": 8097,
	"./orange/nav/report-final.svg": 2641,
	"./orange/nav/report.svg": 6573,
	"./orange/nav/result.svg": 860,
	"./orange/nav/scan.svg": 6068,
	"./orange/password.svg": 1281,
	"./orange/print.svg": 9202,
	"./orange/quickpick.svg": 6301,
	"./orange/refresh.svg": 786,
	"./orange/replay.svg": 5312,
	"./orange/search.svg": 6522,
	"./orange/sign-out.svg": 2782,
	"./orange/user.svg": 4617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4244;